<template>
  <div class="content" id="content">
    <div class="posi">
      当前位置： 首页 &nbsp;>>&nbsp; 学术与交流 &nbsp;>>&nbsp;
      <span>文件中心</span>
    </div>
    <ul class="xlsList">
      <li v-for="(item, index) in fileDataList" :key="index">
        <span>{{ item.fileName }}</span>
        <div>[ {{ item.createTime }} ]</div>
        <button @click="downloadFile(item)">下载</button>
      </li>
    </ul>
    <div class="checkAll_page">
      <div></div>
      <div class="fenye">
        <el-pagination
          class="leftPage"
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="totalSize"
          layout="slot, prev"
        >
          <span
            style="
              font-size: 12px;
              color: #6b6b6b;
              line-height: 34px;
              margin-right: 15px;
            "
            >共<b>{{ totalPage }}</b
            >页</span
          >
          <el-button
            :disabled="firstPageBtnDisabled"
            id="first-pager"
            @click="toFirstPage"
          >
            << 首页</el-button
          >
        </el-pagination>
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="totalSize"
          layout="pager, next, slot, jumper"
        >
          <el-button
            :disabled="lastPageBtnDisabled"
            id="first-pager"
            @click="toLastPage"
            >>> 末页</el-button
          >
        </el-pagination>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageSize: 10, // 每页条数
      pageIndex: 1, // 当前页
      totalSize: 0, // 总条数
      totalPage: 1,
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false,
      lastPageNum: 0, // 尾页是多少
      fileDataList: [],
      downloadFileUrl: window.SITE_CONFIG["baseUrl"],
    };
  },
  mounted() {
    this.initDownloadFiles();
  },
  methods: {
    initDownloadFiles() {
      this.$http({
        url: "/api/infomation/list",
        method: "get",
        params: this.$http.adornParams({
          type: "wjxz",
          pageNo: this.pageIndex,
          length: this.pageSize,
        }),
      })
        .then((response) => {
          let { code, msg, data } = response.data;
          if (code === "1") {
            data.recordList.map((res) => {
              res.createTime = this.$moment(res.createTime).format(
                "YYYY-MM-DD"
              );
            });
            this.fileDataList = data.recordList;
            this.totalSize = data.totalRow;
            this.totalPage = data.totalPage;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((err) => console.log(err));
    },

    downloadFile(fileObj) {
      console.log(fileObj)
      this.$http({
        url: "/api/file/download",
        method: "get",
        params: this.$http.adornParams({
          tbl: "info",
          id: fileObj.id,
          downFileName: fileObj.fileName,
        }),
      })
        .then((response) => {
          if (response.data) {
            window.location.href =
              this.downloadFileUrl +
              `/api/file/download?tbl=info&id=${fileObj.id}`;
          } else {
            this.$message.error("文件不存在")
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 当前页
    currentChangeHandle(val) {
      if (val > 1) {
        this.firstPageBtnDisabled = false;
      } else if (val === this.totalPage) {
        this.lastPageBtnDisabled = true;
      }
      this.pageIndex = val;
      //   this.paid(this.tableStatus);
    },
    // 首页
    toFirstPage() {
      this.pageIndex = 1;
      this.lastPageBtnDisabled = false;
      this.firstPageBtnDisabled = true;
    },
    // 尾页
    toLastPage() {
      this.pageIndex = this.totalPage;
      this.lastPageBtnDisabled = true;
      this.firstPageBtnDisabled = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.xlsList li {
  height: 69px;
  line-height: 69px;
  font-size: 14px;
  color: #333333;
  padding-left: 20px;
  border-bottom: 1px solid #e5e5e5;
}

.xlsList span {
  float: left;
  display: inline-block;
  max-width: 630px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 10px;
}

.xlsList div {
  float: left;
  line-height: 69px;
}

.xlsList button {
  width: 100px;
  height: 36px;
  background-color: #de191c;
  color: #ffffff;
  font-size: 14px;
  border: none;
  outline: none;
  cursor: pointer;
  float: right;
  margin-top: 16px;
  border-radius: 2px;
}
.checkAll_page {
  margin: 70px auto 0;
}
</style>